const lan = {
  REDIRECT: "로딩 중...",
  RULE: {
    SERVICE_TYPE: "서비스 유형을 선택하십시오.",
    COUNTRY: "국가나 지역을 선택하십시오.",
    USERNAME: "사용자 이름 정보가 필요합니다.",
    EMAIL: "이메일 정보가 필요합니다.",
    EMAIL2: "이메일 형식이 올바르지 않습니다.",
    PRODUCT: "제품을 선택하십시오.",
    PRODUCTSN: "제품의 시리얼 번호를 입력하십시오.",
    PRODUCTSN_LEN: "12~15개의 글자 또는 숫자를 입력하십시오.",
    BIRTHDAY: "생일 정보가 필요합니다.",
    REQUIRED: "필수 항목",
  },
  SYS: {
    HEAD: "시스템",
    NOSERVICE:
      "죄송합니다. 선택한 국가 또는 지역에서 ASUS 채팅 서비스를 사용할 수 없습니다.",
    CHECK_FILESIZE: "이미지나 파일의 크기를 확인하십시오. 제한:",
    RECONNECTED: "연결 상태가 정상으로 돌아왔습니다.",
    UNABLE_SEND: "첨부파일을 전송할 수 없습니다.",
    NO_NETWORK: "인터넷 연결 없음",
    NO_NETWORK_INFO:
      "인터넷에 연결되어 있지 않습니다. 인터넷에 연결하고 다시 시도하십시오.",
  },
  IDLE: {
    HEAD: "한동안 응답하지 않았습니다. 대화를 계속하시겠습니까?",
    BUTTON: "계속",
  },
  DISCONNECT: {
    HEAD: "채팅이 종료되었습니다.",
    BUTTON: "종료",
  },
  LAYOUT: {
    STEP_1: "제품 선택",
    STEP_2: "서비스 약관",
    STEP_3: "로그인",
    STEP_4: "정보",
    SELECT_SKILL: "제품 선택",
    PREV_STEP: "이전",
    NEXT_STEP: "다음",
    NOTSET: "설정되지 않음.",
    AGREEN: "동의",
    NOTAGREEN: "동의하지 않음",
    LEAVE: "나가기",
    TYPE_HERE: "여기에 작성하십시오.",
    CHAT_DOWNLOAD:
      "ASUS 온라인 고객 서비스와의 채팅 내용을 저장하려면 여기를 클릭하십시오.",
  },
  COUNTRY: { SELECT_COUNTRY: "서비스 국가나 지역을 선택하십시오." },
  POLICY: {
    PRIVACY: "개인 정보 보호 정책",
    SAT_SURVEY: "서비스 규정",
    CONFIRM_COUNTRY: {
      H1: "친애하는 ASUS 고객님,",
      P1:
        '귀하는 현재 지역과 다른 한국의 "ASUS 온라인 고객 서비스"사이트를 접속하였습니다. ASUS 보증 조건에 따라, 일부 ASUS 제품은 국제 보증 및 지원 서비스가 적용되지 않습니다. 방문하시려는 위의 지역 사이트가 ASUS 제품을 구매한 지역이 아니거나 현재 거주하시는 지역과 다른 경우 서비스에 제한이 있을 수 있습니다. 한국 사이트에서 "ASUS 온라인 고객 서비스"를 계속 사용하거나 해당 지역에 대한 "ASUS 온라인 고객 서비스"를 선택할 수 있습니다.',
      P2: "",
      P3: "",
      B1: "ASUS로 전환",
      B2: "웹사이트",
      B3: "계속 사용",
    },
    BULLETIN: {
      HEAD: "중요 메세지 알림",
      CONFIRM: "알겠습니다.",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "연락 가능한 정보를 입력하십시오.",
    SURVEY_TYPE: "서비스 유형을 선택하십시오.",
    PROBLEM_BRIEF: "문제에 대해 설명하십시오.",
    TYPE1: "일반 질문",
    TYPE2: "수리문의",
    TYPE3: "기술 지원",
    TYPE4: "보증조회",
    TYPE5: "의견 및 피드백",
    EC_TYPE1: "제품 및 구입 정보",
    EC_TYPE2: "마케팅 이벤트",
    EC_TYPE3: "배송 및 주문 상태",
    EC_TYPE4: "환불 서비스",
    SIGNUPDATA: "등록 정보",
    NAME: "이름",
    TEL: "전화번호",
    ORDER_NO: "주문번호",
    BIRTHDAY: "생일",
    LABEL_EMAIL: "이메일",
    EMAIL: "이메일",
    DEVICEINFO: "제품 정보",
    DEVICENAME: "제품명",
    MY_DEVICE: "귀하의 제품",
    MY_DEVICE_SELECT: "제품을 선택하세요.",
    MY_DEVICE_EMPTY: "아직 장치가 없습니다.",
    LABEL_DEVICESN: "시리얼 번호",
    DEVICESN: "제품 시리얼 번호",
    DEVICESN_ERROR: "잘못된 시리얼 번호 입니다.",
    PREPARE: "채팅방 만들기, 채팅 준비",
    START: "채팅 시작",
    AGE_LIMIT: "연령 제한",
    AGE_LIMIT_DESC:
      "ASUS 채팅을 사용할 수 있는 연령의 요구 사항을 충족하지 못했습니다.",
    REPEAT_ENTRY: {
      H1: "진행중인 채팅이 있습니다.",
      P1:
        "새로운 채팅을 시작하시겠습니까? 새로운 채팅이 열리면 이전 채팅은 종료됩니다.",
      B0: "확인",
      B1: "취소",
    },
  },
  CONNECTTING: {
    P1: "잠시만 기다려주십시오. 채팅창을 닫지 마십시오.",
    P2: "ASUS 시스템에서 채팅 가능한 상담원에게 연결하는 중입니다.",
    NOTE: "힌트",
    BEFORE_LEAVE: "이 채팅을 종료하시겠습니까?",
    B0: "종료",
    B1: "계속 대기",
  },
  OFFLIEN: {
    OTHER_CONTACT: "다른 채널로 ASUS에 문의하십시오.",
    MAIL: "이메일 보내기",
    TEL: "전화 상담",
    CLOSE: "닫기",
  },
  WAITTING: {
    WATTING_NUM: "대기 순서",
    PEOPLE: "고객",
    NOTE: "힌트",
    BEFORE_LEAVEL: "대기를 종료하시겠습니까?",
    LEAVE_DESC: "더 이상 대기하지 않으시려면 채팅을 종료하십시오.",
    LEAVE: "대화 종료",
    STAY: "계속 대기",
  },
  CHATROOM: {
    TYPING: "상담사가 작성중입니다...",
    HEAD: {
      CLOSE_AMD_SURVEY: "나가기",
      TERMINATE: "대화 종료",
    },
    FOOTER: { CHAT_FINISH: "채팅이 종료되었습니다." },
    FINISH: "채팅이 종료되었습니다. 추가 서비스나 지원이 필요하십니까?",
    SAT_SURVEY: {
      SAT: "만족",
      DISSAT: "불만족",
      SAT_CHOOSE: "어떤 유형의 서비스입니까?(중복 선택가능)",
      HEAD: "채팅 서비스에 만족하셨나요?",
      DESC:
        "귀하의 피드백을 듣는 것은 저희의 지속적인 발전을 위한 원동력입니다. ASUS 서비스 또는 지원에 대한 제안 사항이 있으면 알려주십시오.",
      OTHER_OPTION: "기타",
      OTHER_REASON: "기타 사유를 입력하십시오.",
      SEND: "발송",
    },
    CLOSE: {
      TITLE: "채팅을 종료하시겠습니까?",
      P1:
        '"종료"를 클릭하여 창을 닫으십시오. 다시 채팅을 원하시는 경우, "새 채팅 시작"을 클릭하십시오.',
      B0: "종료",
      B1: "취소",
    },
  },
  ERROR: {
    H1: "채팅창이 없거나 채팅이 이미 종료되었습니다.",
    CLOSE: "창 닫기",
  },
  CHAT_END: {
    H1: "이용해 주셔서 감사합니다. 채팅이 종료되었습니다.",
    CLOSE: "창 닫기",
  },
  CHAT_CLOSE: {
    H1: "네트워크가 300초 이상 중단되어, 채팅을 종료하였습니다.",
    DESC:
      "무선 네트워크 또는 모바일 네트워크를 사용하는 경우 신호가 더 좋은 위치를 찾거나 유선 네트워크 연결로 전환하여 주십시오. 불편을 끼쳐드려 죄송합니다.",
    CLOSE: "창 닫기",
  },
  SURVEY_DONE: {
    H1: "감사합니다. 서비스 만족도 설문조사를 완료했습니다.",
    P1:
      '귀하의 피드백은 저희의 지속적인 발전의 원동력입니다. 시간을 내어 서비스 만족도 설문조사에 참여해 주셔서 감사합니다. 추가적인 서비스나 지원이 필요하신 경우 "새 채팅 시작"을 클립하십시오. 문제를 해결하신 경우 "창 닫기"를 선택하여 채팅을 종료하십시오.',
    AGAIN: "새 채팅 시작",
    CLOSE: "창 닫기",
    YT_H1:
      "유튜브 ASUS 지원 채널에서 사용 팁과 기술 노하우를 확인하실 수 있습니다.",
    YT_H2: "클릭하여 확인해 보세요!",
  },
  AGENT_OFFLINE: {
    H1: "상담사의 인터넷 연결이 응답하지 않습니다. 현재 채팅이 중단되었습니다.",
    H2: "창을 닫지 마십시오. 채팅을 재개하기 위해 노력하고 있습니다.",
    DESC:
      "설문 조사 진행을 위해 채팅을 종료하거나 '새 채팅 시작'을 누를 수 있습니다. 채팅 서비스를 계속하기 위해 새로운 상담원을 즉시 배정해 드리겠습니다. 불편을 끼쳐드려 죄송합니다.",
    AGAIN: "새 대화 시작",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "카메라와 마이크를 사용할 수 없습니다.",
    H1: "참여하실 준비가 완료되셨습니까?",
    P1:
      "ASUS 고객 서비스 직원이 고객님의 문제를 보다 효율적으로 해결할 수 있도록 영상 채팅방에 참여하려면 장치가 카메라와 마이크에 액세스할 수 있도록 허용해야 하며 모바일 네트워크 연결이 안정적이고 정상적으로 작동하는지 확인해야 합니다.",
    P2:
      "접속 후에도 렌즈 스위치와 마이크 음소거를 자유롭게 설정할 수 있습니다.",
    VIDEO_STATE: "비디오 상태",
    VIDEO_ON: "켜기",
    VIDEO_OFF: "끄기",
    AUDIO_STATE: "오디오 상태",
    AUDIO_ON: "켜기",
    AUDIO_OFF: "끄기",
    ENTER: "참여",
    HANGUP: {
      H1: "종료",
      P1: "비디오 채팅을 종료하시겠습니까?",
      CONFIRM: "확인",
      CANCEL: "취소",
    },
    END: {
      H1: "비디오 콜이 종료되었습니다.",
      P1: "감사합니다. 비디오 콜이 종료되었습니다. 이 창을 닫으셔도 됩니다.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "제품 선택",
      STEP_2: "서비스 약관",
      STEP_3: "로그인",
      STEP_4: "정보",
      SELECT_SKILL: "제품 선택",
      WELCOME: "환영합니다",
      AGREE: "동의",
      START: "시작",
      CANCEL: "취소",
      WAIT: "잠시만 기다려 주시겠습니까?",
      INPUT: "텍스트 입력",
      TRANSFER_TOAGENT: "상담사에게 연결합니다.",
      READMORE: "다음과 같은 관련 FAQ도 참조할 수 있습니다. 감사합니다.",
      COLLAPSE: "숨기기",
      INPUT_SN: "제품의 시리얼번호를 다시 입력해주세요.",
      YOU_MAY_ALSO: "추가로 문의하실 수 있습니다.",
      FOR_FURTHER: "더 많은 정보는 다음을 참조하세요.",
      RECORDING: "말씀해 주세요...",
      RECORDING_NOT_SUPPORTED:
        "사용 중인 브라우저는 음성 인식을 지원하지 않습니다.",
      RECORDING_NOT_FOUND:
        "녹음 장치를 찾을 수 없습니다. 마이크와 권한 설정을 확인해 주세요.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "제품 유형",
      MODEL: "모델명",
      SERIALNO: "제품의 시리얼번호",
      STATUS: "보증 상태",
      DATE: "보증 만료 일자",
    },
    HEAD: {
      LEAVE: "나가기",
      CREATE_NEW: "새로운 채팅방 만들기",
    },
    ENTRANCE: {
      POLICY: "개인정보 보호정책",
      AGREE: "대화를 시작하려면 동의를 클릭합니다.",
    },
    MESSAGE: {
      WAIT: "잠시만 기다려주세요,지금 해결책을 찾고 있습니다.",
    },
    END: "상담 종료",
    END_MSG:
      "고객님께 도움을 드릴 수 있어서 기쁩니다. 이상 대화를 종료하겠습니다. 궁금하신 점이 있으시다면 언제든 다시 찾아주세요.",
    END_SURVEY: "상담 만족도 조사",
    END_SURVEY_MSG:
      "고객님께 도움을 드릴 수 있어서 기쁩니다. 이상 대화를 종료하겠습니다. 궁금하신 점이 있으시다면 언제든 다시 찾아주세요.",
    BACKHOME: "홈페이지로 돌아가기",
    SURVEY: {
      DESC: "ASUS 지니오에 대한 고객님의 경험을 평가 부탁드립니다.",
      SAT: "만족",
      DISSAT: "불만족",
      FEEDBACK: "고객님의 피드백을 작성해주세요",
      SEND: "보내기",
      BACK: "취소",
    },
    SURVEY_DISLIKE: {
      H1: "어떠한 사유로 불만족하셨나요?",
      P:
        "고객님의 소중한 피드백은 당사의 서비스 품질을 개선하는 데 도움이 됩니다.",
      BUTTON: "보내기",
    },
    HISTORY: {
      TITLE: "히스토리",
      AGO: "{hours} 시간 전입니다.",
      CONTINUE: "채팅 계속하기",
      CLOSE: "대화가 종료되었습니다.",
      RESTART: "가상 에이전트로 다시 시작합니다.",
      NON_SERVICE: "운영 외 시간",
      VIEW_HISTORY: "최근 채팅 내역을 확인하려면 클릭하세요.",
    },
  },
};
export default lan;
